module.exports = __webpack_public_path__ + "img/jylogo.b42ffac9.png";